import logger from 'src/logger';
import { request } from '../../../common/rest/index';

/**
 * @deprecated
 * @param product
 */
export const canvas = product => {
  request
    .get(`/phoenix/api/v1/canvas/configure/${product}`)
    .then(response => {
      logger.info(response);
    })
    .catch(error => {
      logger.error(error);
    });
};

export const geoip = () => request.get(`/api/v1/geoip`);

/**
 * Hit the url that is passed in to see if it is available.
 * @param url {String}
 * @returns {Promise<boolean | boolean>}
 */
export const checkIfPageExists = url => {
  // Add a softLook query so that when hitting the page we dont actually log an error
  return request.get(url, { softLook: true })
    .then(() => {
      return true;
    })
    .catch(() => {
      return false;
    });
};


